import { MotionDurationInteractionTable } from '@af/design-system-docs-ui/motion-tables/duration-interaction';
import { MotionDurationTransitionTable } from '@af/design-system-docs-ui/motion-tables/duration-transition';
import { MotionFadeInteractionTable } from '@af/design-system-docs-ui/motion-tables/fade-interaction';
import { MotionFadeTransitionsTable } from '@af/design-system-docs-ui/motion-tables/fade-transition';
import { MotionEasingTable } from '@af/design-system-docs-ui/motion-tables/easing';
import { MotionExitImpliedTable } from '@af/design-system-docs-ui/motion-tables/exit-implied-table';
import { MotionInteractionsTable } from '@af/design-system-docs-ui/motion-tables/interactions';
import { MotionScaleTransitionTable } from '@af/design-system-docs-ui/motion-tables/scale-transition';
import { MotionTransitionsTable } from '@af/design-system-docs-ui/motion-tables/transitions';
import { MotionPlayer } from '@af/design-system-docs-ui/motion-player';
import semanticMotionMapping from "../../../../src/pages/foundations/motion/_assets/semantic-motion-mapping.png";
import doMaintainSpatialAnchors from "../../../../src/pages/foundations/motion/_assets/do-maintain-spatial-anchors.png";
import dontDetachMotionFromSource from "../../../../src/pages/foundations/motion/_assets/dont-detach-motion-from-source.png";
import doConsistentPatterns from "../../../../src/pages/foundations/motion/_assets/do-consistent-patterns.png";
import dontMismatchedPatterns from "../../../../src/pages/foundations/motion/_assets/dont-mismatched-patterns.png";
import doFocusAtStart from "../../../../src/pages/foundations/motion/_assets/do-focus-at-start.png";
import dontFocusAfterMotion from "../../../../src/pages/foundations/motion/_assets/dont-focus-after-motion.png";
import doErrorImmediate from "../../../../src/pages/foundations/motion/_assets/do-error-immediate.png";
import dontErrorDelayed from "../../../../src/pages/foundations/motion/_assets/dont-error-delayed.png";
import doFadeSlideFlag from "../../../../src/pages/foundations/motion/_assets/do-fade-slide-flag.png";
import dontAnimateTooMany from "../../../../src/pages/foundations/motion/_assets/dont-animate-too-many.png";
import doTransformOpacity from "../../../../src/pages/foundations/motion/_assets/do-transform-opacity.png";
import dontLayoutTriggering from "../../../../src/pages/foundations/motion/_assets/dont-layout-triggering.png";
import EasingSpeed50msAnimation from "../../../../src/pages/foundations/motion/_assets/_lottie/easing-speed-50ms.json";
import EasingSpeed200msAnimation from "../../../../src/pages/foundations/motion/_assets/_lottie/easing-speed-200ms.json";
import EasingSpeed250msAnimation from "../../../../src/pages/foundations/motion/_assets/_lottie/easing-speed-250ms.json";
import * as React from 'react';
export default {
  MotionDurationInteractionTable,
  MotionDurationTransitionTable,
  MotionFadeInteractionTable,
  MotionFadeTransitionsTable,
  MotionEasingTable,
  MotionExitImpliedTable,
  MotionInteractionsTable,
  MotionScaleTransitionTable,
  MotionTransitionsTable,
  MotionPlayer,
  semanticMotionMapping,
  doMaintainSpatialAnchors,
  dontDetachMotionFromSource,
  doConsistentPatterns,
  dontMismatchedPatterns,
  doFocusAtStart,
  dontFocusAfterMotion,
  doErrorImmediate,
  dontErrorDelayed,
  doFadeSlideFlag,
  dontAnimateTooMany,
  doTransformOpacity,
  dontLayoutTriggering,
  EasingSpeed50msAnimation,
  EasingSpeed200msAnimation,
  EasingSpeed250msAnimation,
  React
};